
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import {
  Operation, PermissionCode, User,
} from '@/types';
import EditLeadSupplyDialog from '@/components/EditLeadSupplyDialog.vue';

moment.locale('it');

@Component({
  components: {
    EditLeadSupplyDialog,
  },
})
export default class OperationOrderConfirmationDate extends Vue {
  @Prop(Object) readonly operation!: Operation;

  editDialog = false

  loading = false

  @Watch('editDialog')
  onEditDialogChange(val: boolean) {
    if (val === false) {
      this.$nextTick(() => {
        (this.$refs.tippyRef as any).tippy().hide();
      });
    }
  }

  @Watch('amIUpdating')
  onAmIUpdatingChange(val: boolean, oldVal: boolean) {
    if (oldVal === true && val === false) {
      // La commessa è stata aggiornata - non ci sono note specifiche per orderConfirmationDate
    }
  }

  get poolUpdating(): { [key: number]: boolean } {
    return this.$store.getters.currentOperationsPoolUpdating;
  }

  get amIUpdating(): boolean {
    return this.operation
      && this.operation.id in this.poolUpdating
      && this.poolUpdating[this.operation.id] === true;
  }

  get orderConfirmationDate(): string | null {
    return this.operation
      && this.operation.orderConfirmationDate
      && moment(this.operation.orderConfirmationDate).isValid()
      ? moment(this.operation.orderConfirmationDate).format('L')
      : null;
  }

  get isEditable() {
    if (!this.operation) return false;

    // Se l'utente non ha accesso alla lead padre, non può modificare la data di conferma ordine
    if (!this.isCurrentUserAllowed) return false;

    return this.operation
      && 'status' in this.operation
      && (this.operation.status === 'open' || this.operation.status === 'new')
      && this.hasPermission('orderConfirmationDate.edit');
  }

  get operationAllowedUsers(): number[] {
    return this.operation.allowedUsers.substring(1, this.operation.allowedUsers.length - 1).split(':')
      .map((s: string) => Number(s));
  }

  get isCurrentUserAllowed(): boolean {
    return this.operationAllowedUsers.includes(this.user.id);
  }

  async onEdit() {
    this.loading = true;

    await this.$store.dispatch('selectLead', { id: this.operation.id });

    this.$nextTick(() => {
      (this.$refs.tippyRef as any).tippy().hide();
    });

    this.editDialog = true;

    this.loading = false;
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get userPermissions(): PermissionCode[] {
    return this.$store.getters.currentUserPermissions;
  }

  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  onTooltipShow() {
    console.log('OperationOrderConfirmationDate: onTooltipShow()'); // eslint-disable-line no-console
  }

  onTooltipHide() {
    // Nothing to do
  }
}
